var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.statusCode === 200)?_c('router-view',{key:_vm.$route.fullPath}):(_vm.statusCode)?_c('div',[_c('error',{attrs:{"status-code":_vm.statusCode}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }